import React from "react";

import SliderFormElementV2 from "../../../formElement/SliderFormElementV2";


const values = [1, 2, 3, 4, 5, 6, 7];
const newDesignLabels = {
  1: <>Defensiv<br/>1 - 2</>,
  4: <>Moderat<br/>3 - 5</>,
  7: <>Offensiv<br/>6 - 7</>
};

const muiSliderMax = 100;

const marks = values.map((value, index) => ({
  value: muiSliderMax / (values.length - 1) * index,
  label: value
}));
const newDesignMarks = marks.map(m => ({...m, label: newDesignLabels[m.label]}));
const step = muiSliderMax / (values.length - 1);

const RiskProfileSlider = ({disabled, sri, noProfile, onChange, maxSRI}) => {
  const max = noProfile ? undefined : (maxSRI - 1) * step || 1;

  const sliderStyle = {
    position: 'absolute',
    left: 0,
    right: `${noProfile ? 0 : (100 - max)}%`,
    top: 0,
    width: 'auto'
  };

  if(noProfile){
    sliderStyle.color = 'transparent';
  }

  const handleChange = (value) => {
    const mark = marks.find(item => item.value === value);
    if(mark){
      onChange(mark.value / step + 1);
    }
  };

  return (
    <SliderFormElementV2
      disabled={disabled}
      value={noProfile ? undefined : (sri - 1) * step}
      label={sri}
      step={step}
      marks={newDesignMarks}
      max={max}
      onChange={handleChange}
      style={sliderStyle}
    />
  )
}

export default RiskProfileSlider;